<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Gestión Clínica</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Historial de Pacientes</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button type="button" class="btn btn-primary btn-block" (click)="load()">
      <i class="fa fa-refresh me-1"></i>
      Actualizar
    </button>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card filter-card">
      <div class="card-body">
        <form [formGroup]="filtrosForm" class="date-filter-form" (ngSubmit)="aplicarFechas()">
          <div class="filter-title">FILTRAR</div>
          <div class="date-filter-grid">
            <div>
              <label>Desde</label>
              <input type="date" class="form-control" formControlName="fechaInicio">
            </div>
            <div>
              <label>Hasta</label>
              <input type="date" class="form-control" formControlName="fechaFin">
            </div>
            <div class="date-filter-actions">
              <button type="submit" class="btn btn-secondary">
                <i class="fa fa-filter me-1"></i>
                Aplicar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-body">
        <div class="table-controls">
          <div class="show-records">
            Mostrar
            <select class="form-control form-control-sm" [value]="limit" (change)="cambiarLimite($any($event.target).value)">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            registros
          </div>
          <div class="search-box">
            <label>Buscar:</label>
            <input
              type="text"
              class="form-control form-control-sm"
              [ngModel]="searchTerm"
              (ngModelChange)="buscarMientrasEscribe($event)"
              placeholder="Paciente, documento, orden, factura, médico..."
              >
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="limpiar()">Limpiar</button>
          </div>
        </div>

        <div *ngIf="loading" class="text-center loading-state">
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-center mt-2">Procesando por favor espere...</p>
        </div>

        <div class="table-responsive" *ngIf="!loading">
          <table class="table table-bordered table-striped table-hover dt-ext records-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Paciente</th>
                <th>Documento</th>
                <th>Médico consulta</th>
                <th>Sucursal</th>
                <th>Orden</th>
                <th>Factura</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows; let rowIndex = index">
                <td>{{ offset + rowIndex + 1 }}</td>
                <td>{{ row.created_at | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                <td><strong>{{ row.patient_name }}</strong></td>
                <td>{{ row.patient_document }}</td>
                <td>{{ row.created_by_name || row.order_doctor_name }}</td>
                <td>{{ row.branch_name || '-' }}</td>
                <td>{{ row.order_number }}</td>
                <td>{{ row.invoice_number || '-' }}</td>
                <td>
                  <div ngbDropdown class="d-inline-block" container="body" placement="bottom-right">
                    <button type="button" class="btn btn-primary btn-sm action-button" ngbDropdownToggle>
                      <i class="fa fa-cog"></i>
                    </button>
                    <div ngbDropdownMenu>
                      <button ngbDropdownItem type="button" (click)="verPdf(row)">
                        <i class="zmdi zmdi-collection-pdf me-1"></i> Ver Historia Clínica
                      </button>
                      <button ngbDropdownItem type="button" (click)="editar(row)">
                        <i class="zmdi zmdi-edit me-1"></i> Editar Historia Clínica
                      </button>
                      <button ngbDropdownItem type="button" (click)="agregarEvolucion(row)">
                        <i class="zmdi zmdi-plus-circle-o me-1"></i> Agregar Evolución
                      </button>
                      <button ngbDropdownItem type="button" (click)="verEvoluciones(row)">
                        <i class="zmdi zmdi-time-restore me-1"></i> Ver Evoluciones
                      </button>
                      <button ngbDropdownItem type="button" (click)="verOrdenes(row)">
                        <i class="zmdi zmdi-assignment me-1"></i> Ver Órdenes Relacionadas
                      </button>
                      <button *ngIf="canViewAudit" ngbDropdownItem type="button" (click)="verAuditoria(row)">
                        <i class="zmdi zmdi-time-countdown me-1"></i> Ver Auditoría
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="rows.length === 0">
                <td colspan="9" class="empty-state">No existen datos</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-footer">
          <div>Mostrando desde {{ desde }} al {{ hasta }} de {{ total }} elementos</div>
          <div class="pagination-actions">
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset === 0" (click)="primeraPagina()">Primero</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset === 0" (click)="paginaAnterior()">Ant</button>
            <button class="btn btn-sm btn-primary" type="button">{{ paginaActual }}</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset + limit >= total" (click)="paginaSiguiente()">Sig</button>
            <button class="btn btn-sm btn-outline-primary" type="button" [disabled]="offset + limit >= total" (click)="ultimaPagina()">Último</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalEvolucion let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Agregar evolución clínica</h5>
      <small *ngIf="selectedRecord">
        {{ selectedRecord.patient_name }} · {{ selectedRecord.patient_document }}
      </small>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cerrarPanel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="evolution-help">
      Registre el seguimiento posterior a la historia inicial: cómo llega el paciente, qué encuentra el profesional y qué indicaciones se dejan.
    </div>
    <form [formGroup]="evolutionForm" (ngSubmit)="guardarEvolucion()">
      <div class="row row-sm">
        <div class="col-md-6 mb-3">
          <label class="required-label">LO QUE REFIERE EL PACIENTE</label>
          <textarea class="form-control" rows="3" formControlName="subjective" placeholder="Ej: refiere mejoría, dolor persistente, nuevos síntomas, controles realizados..."></textarea>
        </div>
        <div class="col-md-6 mb-3">
          <label>HALLAZGOS DEL PROFESIONAL</label>
          <textarea class="form-control" rows="3" formControlName="objective" placeholder="Ej: signos vitales, examen físico, resultados revisados, cambios observados..."></textarea>
        </div>
        <div class="col-md-6 mb-3">
          <label>IMPRESIÓN / ANÁLISIS CLÍNICO</label>
          <textarea class="form-control" rows="3" formControlName="assessment" placeholder="Ej: evolución favorable, diagnóstico probable, respuesta al tratamiento..."></textarea>
        </div>
        <div class="col-md-6 mb-3">
          <label class="required-label">PLAN E INDICACIONES</label>
          <textarea class="form-control" rows="3" formControlName="plan" placeholder="Ej: continuar tratamiento, solicitar examen, control en 7 días, signos de alarma..."></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrarPanel()">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="guardarEvolucion()">Guardar evolución clínica</button>
  </div>
</ng-template>

<ng-template #modalAuditoria let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Auditoría clínica</h5>
      <small *ngIf="selectedRecord">
        {{ selectedRecord.patient_name }} · {{ selectedRecord.patient_document }}
      </small>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cerrarPanel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="loadingAudit" class="text-center loading-state">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-center mt-2">Procesando por favor espere...</p>
    </div>

    <div class="table-responsive" *ngIf="!loadingAudit && auditRows.length > 0">
      <table class="table table-bordered table-striped table-hover records-table mb-0">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Acción</th>
            <th>Usuario</th>
            <th>IP</th>
            <th>Dispositivo</th>
            <th>Resolución</th>
            <th>Detalle</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let audit of auditRows">
            <td>{{ audit.created_at | date:'yyyy-MM-dd HH:mm:ss' }}</td>
            <td>{{ auditActionLabel(audit.action) }}</td>
            <td>{{ audit.user_name || audit.user_login || '-' }}</td>
            <td>{{ audit.ip || '-' }}</td>
            <td>{{ audit.device || '-' }}</td>
            <td>{{ audit.screen_resolution || '-' }}</td>
            <td>{{ audit.description || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="empty-state" *ngIf="!loadingAudit && auditRows.length === 0">No existen datos</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrarPanel()">Cerrar</button>
  </div>
</ng-template>

<ng-template #modalOrdenes let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Órdenes relacionadas</h5>
      <small *ngIf="selectedRecord">
        {{ selectedRecord.patient_name }} · {{ selectedRecord.patient_document }}
      </small>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cerrarPanel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="loadingRelatedOrders" class="text-center loading-state">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-center mt-2">Procesando por favor espere...</p>
    </div>

    <div class="table-responsive" *ngIf="!loadingRelatedOrders && relatedOrders.length > 0">
      <table class="table table-bordered table-striped table-hover records-table mb-0">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Orden</th>
            <th>Factura</th>
            <th>Doctor</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of relatedOrders">
            <td>{{ order.fecha | date:'yyyy-MM-dd HH:mm:ss' }}</td>
            <td>{{ order.order_number }}</td>
            <td>{{ order.invoice_number || '-' }}</td>
            <td>{{ order.doctor_name || '-' }}</td>
            <td>{{ order.estado || '-' }}</td>
            <td>
              <button class="btn btn-sm btn-primary" type="button" (click)="abrirOrden(order)">
                <i class="fa fa-file-pdf-o me-1"></i>
                Ver PDF
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="empty-state" *ngIf="!loadingRelatedOrders && relatedOrders.length === 0">No existen datos</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrarPanel()">Cerrar</button>
  </div>
</ng-template>

<ng-template #modalEvoluciones let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Evoluciones clínicas</h5>
      <small *ngIf="selectedRecord">
        {{ selectedRecord.patient_name }} · {{ selectedRecord.patient_document }}
      </small>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cerrarPanel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="loadingEvolutions" class="text-center loading-state">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="text-center mt-2">Procesando por favor espere...</p>
    </div>

    <div class="evolution-list" *ngIf="!loadingEvolutions && evolutionRows.length > 0">
      <div class="evolution-item" *ngFor="let evolution of evolutionRows; let evolutionIndex = index">
        <div class="evolution-item-header">
          <strong>Evolución {{ evolutionRows.length - evolutionIndex }}</strong>
          <span>{{ evolution.evolution_date | date:'yyyy-MM-dd HH:mm:ss' }}</span>
        </div>
        <div class="evolution-grid">
          <div *ngIf="evolution.subjective"><b>Lo que refiere el paciente:</b> {{ evolution.subjective }}</div>
          <div *ngIf="evolution.objective"><b>Hallazgos del profesional:</b> {{ evolution.objective }}</div>
          <div *ngIf="evolution.assessment"><b>Impresión / análisis clínico:</b> {{ evolution.assessment }}</div>
          <div *ngIf="evolution.plan"><b>Plan e indicaciones:</b> {{ evolution.plan }}</div>
          <div *ngIf="evolution.created_by_name"><b>Registrado por:</b> {{ evolution.created_by_name }}</div>
        </div>
      </div>
    </div>
    <div class="empty-state" *ngIf="!loadingEvolutions && evolutionRows.length === 0">No existen datos</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrarPanel()">Cerrar</button>
  </div>
</ng-template>
